<div class="wizard">
    <header class="wizard__header">
        <priva-header [title]="title()" size="lg" heading="h1" />

        <priva-wizard-indicator
            class="margin-top-1"
            (stepClick)="onIndicatorStepClick($event)"
            (isMobileBreakpoint)="onBreakpointChange($event)"
            [activeStepIndex]="stepIndex"
            [breakpoint]="breakpoint"
            [hasResponsiveBehavior]="false"
            [isInteractive]="false"
            [steps]="steps"
            stepDelimiter="of"
            data-test="wizard-step-indicator"
        />
    </header>

    <div class="wizard__main">
        <ng-content />
    </div>

    <priva-wizard-toolbar
        class="wizard__footer"
        (buttonClick)="onToolbarButtonClick($event)"
        [activeStep]="stepIndex"
        [buttons]="buttons()"
        [steps]="steps"
    />
</div>
